import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const ViewCategoryDialog = ({ openViewDialog, handleCloseViewDialog, selectedCategoryIndex, categories }) => (
      <Dialog open={openViewDialog} onClose={handleCloseViewDialog}>
        <DialogTitle style={{ fontSize: "20px", width: "350px" }}>
          Category Details
        </DialogTitle>
        <DialogContent>
          {selectedCategoryIndex !== null && categories[selectedCategoryIndex] && (
            <div>
              <Typography sx={{ fontSize: "18px" }}>
                Name:{" "}
                <span style={{ fontWeight: 400 }}>
                  {categories[selectedCategoryIndex].name}
                </span>
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                Type:{" "}
                <span style={{ fontWeight: 400 }}>
                  {categories[selectedCategoryIndex].type}
                </span>
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                Hashtags:{" "}
                <span style={{ fontWeight: 400 }}>
                  {categories[selectedCategoryIndex].hashtags.join(", ")}
                </span>
              </Typography>

              {categories[selectedCategoryIndex].logo ? (
                <div
                  style={{
                    marginTop: "2px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "18px" }}
                    style={{ marginRight: "8px" }}
                  >
                    Logo:
                  </Typography>
                  {categories[selectedCategoryIndex].logo.startsWith("http") ? (
                    <img
                      src={categories[selectedCategoryIndex].logo}
                      alt="Category Logo"
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <Typography variant="body1">
                      {categories[selectedCategoryIndex].logo}
                    </Typography>
                  )}
                </div>
              ) : (
                <Typography variant="body1" color="textSecondary">
                  No logo available
                </Typography>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseViewDialog}>Close</Button>
        </DialogActions>
      </Dialog>
);

export default ViewCategoryDialog;
